import React, { useState, useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import Navbar from "../../components/common/Navbar/Navbar";
import Loading from "../../components/common/Loading/Loading";
import Searchbar from "../../components/snapshots/Utils/Searchbar";
import SnapshotsTabs from "../../components/snapshots/Tabs/SnapshotTabs";
import SnapshotsTable from "../../components/snapshots/Table/SnapshotsTable";
import NoSnapshotsMessage from "../../components/snapshots/Utils/NoSnapshots";
import { getAllSnapshotsData } from "../../components/s3/GetSnapshotsTableData";
import { filterDataByStatus } from "../../components/snapshots/Utils/FilterFunctions";
import {submitSettings} from "../../components/snapshots/Utils/SubmitSettings"

import "./snapshots.css";
import { useRepoSelected } from "../../components/context/RepoContext";

let empty = false;

function Snapshots() {
  // State variables
  const [toggleState, setToggleState] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");
  const [spinner, setSpinner] = useState(true);
  const [repos, setRepos] = useState([]);
  const [data, setData] = useState([]);
  const [comp, setComp] = useState([]);

  const getCompanies = useOutletContext().getCompanies;
  const getRepositories = useOutletContext().getRepositories;
  var choices = [];
  var managerChoices = [];
  const { setRepoSelected, repoSelected } = useRepoSelected();
  const getS3 = useOutletContext().getS3;
  const [S3, setS3] = useState(null);

  useEffect(() => {
    getS3().then(setS3);
  }, [S3])

  // Function fetchData is used to fetch Data from S3
  async function fetchData() {
    setSpinner(true);
    setData([]);
    const s3Data = await getAllSnapshotsData(S3);
    setData(s3Data);
    setSpinner(false);
  }

  // Enable toggle functionality for tabs (active tab)
  const toggleTab = (status) => {
    setToggleState(status);
  };

  // Function selectValue is used to handle repository selection
  const selectValue = (event) => {
    if (event.target.value !== "Select") {
      localStorage.setItem("repoName", event.target.value);
      submitSettings(event);
      fetchData();
      setRepoSelected(true);
    } else {
      localStorage.setItem("repoName", "");
      submitSettings(event);
      fetchData();
      setRepoSelected(false);
    }
  };

  // This function filters and sorts data according to the status to be displayed on the snapshots table
  const filteredData = filterDataByStatus(toggleState, data).filter((item) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Function select is used to handle company selection
  const select = (event) => {
    // Add the selected company to local storage
    localStorage.setItem("company", event.target.value);
  };

  useEffect(() => {
    if(!S3) return;
    //remove timestamp to prevent from accessing latest report from url
    localStorage.removeItem("timestamp");
    // Fetch data and companies/repositories and add them to arrays
    Promise.all([getRepositories(), getCompanies()])
      .then(([repoData, companyData]) => {
        repoData.forEach((item) => {
          let arr = item.Key.split("/");
          if (arr.length > 0) {
            if (choices.includes(arr[2]) === false && arr[2] !== "") {
              choices.push(arr[2]);
            }
          }
        });

        companyData.forEach((item) => {
          let arr = item.Key.split("/");
          if (arr.length > 0) {
            if (managerChoices.includes(arr[0]) === false) {
              managerChoices.push(arr[0]);
            }
          }
        });

        setRepos(choices);
        setComp(managerChoices);
      })
      .finally(() => {
        // Fetch data only after the other data is loaded
        fetchData();
      });
      
  }, [S3]);

  //If the Repo os not set New Snapshot button is disabled
  useEffect(() => {
    const repoName = localStorage.getItem("repoName");
    setRepoSelected(repoName ? true : false);
  }, [repoSelected, setRepoSelected]);

  return (
    <>
      <Navbar />
      <div className="grid-container">
        <div className="header">
          <div className="header-title">Snapshots</div>

          {/* This is the search bar component that includes company and repo name dropdowns */}
          <Searchbar
            select={select}
            selectValue={selectValue}
            comp={comp}
            repos={repos}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            repoSelected={repoSelected}
          />
        </div>

        {/* Tabs component to filter out existing snapshots (All, In Progress, Submitted) */}
        <SnapshotsTabs toggleState={toggleState} toggleTab={toggleTab} />

        {spinner ? (
          <div
          style={{
            display: "flex",
            justifyContent: "center",
            fontSize: "14px",
            position: "absolute",
            right: "50%",
            top: "50%",
          }}
        >
          <Loading />
        </div>
        ) : !data.length ? (
          <NoSnapshotsMessage empty={empty} />
        ) : filteredData.length === 0 ? (
          <div className="no-snapshots">
              There are no{" "}
              {toggleState.toLowerCase() !== "all"
                ? toggleState + " "
                : ""}
              snapshots. Please email contact@hecoanalytics.com if you think
              something is missing.
            </div>
        ) : (
          <SnapshotsTable data={filteredData} />
        )}
      </div>
    </>
  );
}

export default Snapshots;
